export default __webpack_public_path__ + "static/media/you-are-gay-79.05b93492.png";